import { useEffect, useState } from "react";
import { theme as themeDefault } from "theme";

const useCreateTheme = () => {
  const [theme, setTheme] = useState(themeDefault);

  const loadTheme = () => {
    setTheme({
      ...themeDefault,
      rootFontSize: process.env.REACT_APP_ROOT_FONT_SIZE || "1rem",
      fontFamily: `${process.env.REACT_APP_FONT_FAMILY}, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
      fontFamilySpecial: `${
        process.env.REACT_APP_FONT_SPECIAL_FAMILY ||
        process.env.REACT_APP_FONT_FAMILY
      }, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
      inputFontFamily:
        process.env.REACT_APP_INPUT_FONT_FAMILY ||
        process.env.REACT_APP_FONT_FAMILY ||
        theme.fontFamily,
      colorPrimary: process.env.REACT_APP_COLOR_PRIMARY,
      colorPrimaryText: process.env.REACT_APP_COLOR_PRIMARY_TEXT || "white",
      colorAccent:
        process.env.REACT_APP_COLOR_ACCENT ||
        process.env.REACT_APP_COLOR_PRIMARY,
      colorAccentText:
        process.env.REACT_APP_COLOR_ACCENT_TEXT ||
        process.env.REACT_APP_COLOR_PRIMARY_TEXT ||
        "white",
      colorDark: process.env.REACT_APP_COLOR_DARK || "#1f1f1f",
      colorDarkText: process.env.REACT_APP_COLOR_DARK_TEXT || "white",
      colorBackground:
        process.env.REACT_APP_COLOR_BACKGROUND ||
        process.env.REACT_APP_COLOR_PRIMARY,
      colorSuccess: process.env.REACT_APP_COLOR_SUCCESS,
      colorSuccessText: process.env.REACT_APP_COLOR_SUCCESS_TEXT || "white",
      colorDanger: process.env.REACT_APP_COLOR_DANGER || theme.colorDanger,
      colorDangerText: process.env.REACT_APP_COLOR_DANGER_TEXT || "white",
      colorBurgerTitleBackground:
        process.env.REACT_APP_COLOR_BURGER_HEADER ||
        process.env.REACT_APP_COLOR_DARK ||
        "#1f1f1f",
      colorBurgerTitleText:
        process.env.REACT_APP_COLOR_BURGER_TEXT || theme.colorDarkText,
      colorTopbar:
        process.env.REACT_APP_COLOR_TOPBAR ||
        process.env.REACT_APP_COLOR_PRIMARY,
    });
  };

  useEffect(() => {
    loadTheme();
  }, []);

  console.log("theme", theme);

  return [theme];
};

export default useCreateTheme;
